import type { ReportTemplateDetailDto } from "../../api/reportTemplateService"
import { formatDateTime } from "./editorUtils"

import { Badge } from "shared/ui/badge"
import { Card, CardContent } from "shared/ui/card"
import { Label } from "shared/ui/label"

type TemplateSummaryCardProps = {
  template: ReportTemplateDetailDto
}

export function TemplateSummaryCard({ template }: TemplateSummaryCardProps) {
  return (
    <Card>
      <CardContent className="py-6">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Label className="text-xs text-gray-500">Code</Label>
            <div className="font-semibold text-gray-900">{template.code}</div>
          </div>
          <div>
            <Label className="text-xs text-gray-500">Template Name</Label>
            <div className="font-semibold text-gray-900">{template.name}</div>
          </div>
          <div>
            <Label className="text-xs text-gray-500">Version</Label>
            <div className="font-semibold text-gray-900">v{template.version}</div>
          </div>
          <div>
            <Label className="text-xs text-gray-500">Status</Label>
            <div>
              <Badge className={template.isActive ? "bg-emerald-100 text-emerald-700" : "bg-gray-200 text-gray-700"}>
                {template.isActive ? "ACTIVE" : "INACTIVE"}
              </Badge>
            </div>
          </div>
        </div>
        <div className="mt-4 text-sm text-gray-500">Updated: {formatDateTime(template.updatedAt || template.createdAt)}</div>
      </CardContent>
    </Card>
  )
}

